import * as types from "./types";

export const getCompanyDashboardOverviewRequest = () => ({
  type: types.GET_COMPANY_DASHBOARD_OVERVIEW_REQUEST,
});

export const getCompanyDashboardOverviewResponse = (payload) => ({
  type: types.GET_COMPANY_DASHBOARD_OVERVIEW_RESPONSE,
  payload,
});

export const getCompanyDashboardOngoingEventsRequest = () => ({
  type: types.GET_COMPANY_DASHBOARD_ONGOING_EVENTS_REQUEST,
});

export const getCompanyDashboardOngoingEventsResponse = (payload) => ({
  type: types.GET_COMPANY_DASHBOARD_ONGOING_EVENTS_RESPONSE,
  payload,
});

export const getCompanyDashboardOverviewFailure = () => ({
  type: types.GET_COMPANY_DASHBOARD_OVERVIEW_FAILURE,
});

export const getCompanyDashboardOngoingEventsFailure = () => ({
  type: types.GET_COMPANY_DASHBOARD_ONGOING_EVENTS_FAILURE,
});

export const getCompanyDashboardClientSatisfactionRequest = () => ({
  type: types.GET_COMPANY_DASHBOARD_CLIENT_SATISFACTION_REQUEST,
});

export const getCompanyDashboardClientSatisfactionResponse = (payload) => ({
  type: types.GET_COMPANY_DASHBOARD_CLIENT_SATISFACTION_RESPONSE,
  payload,
});

export const getCompanyDashboardClientSatisfactionFailure = () => ({
  type: types.GET_COMPANY_DASHBOARD_CLIENT_SATISFACTION_FAILURE,
});

export const getCompanyDashboardTopEventsRequest = () => ({
  type: types.GET_COMPANY_DASHBOARD_TOP_EVENTS_REQUEST,
});

export const getCompanyDashboardTopEventsResponse = (payload) => ({
  type: types.GET_COMPANY_DASHBOARD_TOP_EVENTS_RESPONSE,
  payload,
});

export const getCompanyDashboardTopEventsFailure = () => ({
  type: types.GET_COMPANY_DASHBOARD_TOP_EVENTS_FAILURE,
});

export const getCompanyDashboardRecentActivityRequest = () => ({
  type: types.GET_COMPANY_DASHBOARD_RECENT_ACTIVITY_REQUEST,
});

export const getCompanyDashboardRecentActivityResponse = (payload) => ({
  type: types.GET_COMPANY_DASHBOARD_RECENT_ACTIVITY_RESPONSE,
  payload,
});

export const getCompanyDashboardRecentActivityFailure = () => ({
  type: types.GET_COMPANY_DASHBOARD_RECENT_ACTIVITY_FAILURE,
});
